<template>
  <b-modal id="infopopup" ref="InfoPopupModel" size="lg" no-close-on-esc no-close-on-backdrop :no-enforce-focus="true">
    <template slot="modal-header" class="mx-auto">
      <h5 class="modal-title">{{title}}</h5>
    </template>
    <template slot="default">
      <p>{{popupmessage}}</p>
    </template>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="closeMessage()" id="btnclose">Close</b-button>
      <b-button v-if="title != '' && src == 'account' && title == 'Information'" class="um-btn" @click="cancelAction()">Cancel</b-button>
    </template>
  </b-modal>
</template>
<script>
import { eventbus } from "../../main";
export default {
  name: "InfoPopup",
  props: {
    src: String,
    popupmessage: String,
    title: {
      type: String,
      default: "Information"
    }
  },
  methods: {
    closeMessage: function() {
      if (this.src == "accounts") {
        eventbus.$emit("accountsOkChanges");
      } else {
        eventbus.$emit("confirmOkChanges");
      }
    },
    cancelAction:function(){
      this.$bvModal.hide("infopopup");
    }
  }
};
</script>

<style scoped>
.adduserbtn {
  margin-left: 0.8em;
  background-color: #2c87f0;
  border: 1px solid #2c87f0;
  height: 2.6em;
  border-radius: 5px;
  font-size: 0.8em;
  color: white;
  width: 5.2em;
}
</style>
<style>
.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}
</style>